

export enum CommanClass {
    Submenu_Class = 'submenu-margin',
    ShowMenu_Class = 'show-menu',
    SidebarOpen_Class = 'sidebar open overflow-menu',
}

